import {
  FormControl,
  FormLabel,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormErrorMessage,
} from "@chakra-ui/react";
import { forwardRef, ForwardRefRenderFunction } from "react";
import { FieldError } from "react-hook-form";

interface Props extends ChakraInputProps {
  name: string;
  label?: string;
  size?: "lg" | "md" | "sm";
  error?: FieldError;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, Props> = (
  { name, label, size = "lg", error, ...rest },
  ref
) => {
  return (
    <FormControl isInvalid={!!error}>
      {label && (
        <FormLabel color="gray.800" fontWeight="bold" htmlFor={name}>
          {label}
        </FormLabel>
      )}

      <ChakraInput
        {...rest}
        id={name}
        name={name}
        borderColor="gray.400"
        borderWidth={1}
        focusBorderColor="green.600"
        bgColor="white"
        variant="filled"
        size={size}
        _hover={{
          bgColor: "white",
        }}
        ref={ref}
      />
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const Input = forwardRef(InputBase);
